var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8417 7.21165C15.9967 6.58415 15.03 6.31165 14.06 6.41498C14.0967 6.32081 14.13 6.22831 14.1584 6.13665C14.5209 4.95915 14.3 3.73915 13.5342 2.70248C12.6959 1.56665 11.3084 0.833313 10 0.833313C8.69171 0.833313 7.30504 1.56748 6.46588 2.70248C5.70004 3.73915 5.47921 4.95915 5.84171 6.13665C5.87004 6.22831 5.90254 6.32081 5.94004 6.41498C4.96921 6.31081 4.00338 6.58415 3.15838 7.21165C2.03838 8.04415 1.31421 9.40748 1.31421 10.6841C1.31421 11.9608 2.03838 13.3241 3.15838 14.1566C3.88671 14.6975 4.70421 14.975 5.53838 14.975C5.91088 14.975 6.28671 14.92 6.65838 14.8075C7.35838 14.5958 8.02504 14.1383 8.60921 13.6133C8.48421 15.0316 8.21588 16.195 7.35504 16.7225H6.32504C5.65004 16.7225 5.10254 17.2691 5.10254 17.945C5.10254 18.6208 5.65004 19.1675 6.32504 19.1675H13.6742C14.3492 19.1675 14.8967 18.6208 14.8967 17.945C14.8967 17.2691 14.3492 16.7225 13.6742 16.7225H12.5892C11.73 16.1941 11.4625 15.0083 11.3342 13.5625C11.9309 14.1083 12.6184 14.5891 13.3409 14.8075C13.7134 14.92 14.0892 14.975 14.4609 14.975C15.2942 14.975 16.1125 14.6975 16.8409 14.1566C17.9609 13.3241 18.685 11.9608 18.685 10.6841C18.685 9.40748 17.9617 8.04415 16.8417 7.21165Z",
    fill: "url(#paint0_linear_192_459)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_459",
    x1: 9.99963,
    y1: 0.833313,
    x2: 9.99963,
    y2: 19.1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.ac46c232c48fa649258614b2e84f22c6.svg";
export { ForwardRef as ReactComponent };